import React, { useContext, useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  Paper,
  TextField,
  Typography,
} from '@material-ui/core';
import { AlertContext } from '../../Context/AlertContextProvider';
import { submitFeatureRequest } from './featureRequestActions';

export default function SubmitFeatureRequestDialog({ isOpen, onClose, onSubmitted }) {
  const { handleAlertOpen, setMessage, setMessageType } = useContext(AlertContext);

  const [details, setDetails] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setDetails('');
  }, [isOpen]);

  const handleSubmit = () => {
    if (!details.trim()) {
      setMessage('Please describe the feature you would like');
      setMessageType('error');
      handleAlertOpen();
      return;
    }
    setSaving(true);
    submitFeatureRequest(details.trim())
      .then(() => {
        setMessage(
          'Feature request submitted — track its status under My Requests'
        );
        setMessageType('success');
        handleAlertOpen();
        onSubmitted && onSubmitted();
        onClose();
      })
      .catch((err) => {
        setMessage(
          err?.response?.data?.message || 'Error submitting feature request'
        );
        setMessageType('error');
        handleAlertOpen();
      })
      .finally(() => setSaving(false));
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <Paper style={{ padding: 20 }}>
        <Typography variant="h6" style={{ marginBottom: 8 }}>
          <b>Request a Feature</b>
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginBottom: 16 }}
        >
          Tell us what you'd like ShowroomPricing to do. Our team reviews every
          request — if accepted, it's opened up for other customers to vote on
          (anonymously).
        </Typography>
        <TextField
          label="What would you like to see?"
          variant="outlined"
          fullWidth
          multiline
          minRows={5}
          value={details}
          onChange={(e) => setDetails(e.target.value)}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 8,
            marginTop: 16,
          }}
        >
          <Button onClick={onClose}>Cancel</Button>
          <Button
            variant="contained"
            style={{ background: '#FF682C', color: '#fff' }}
            disabled={saving}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      </Paper>
    </Dialog>
  );
}
